import { ptBR } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';

const ProduttivoMuiThemeV2 = createTheme(
    {
        spacing: 4,
        shape: { 
            none: 0,
            borderRadius: 4,
            borderRadius1: 4,
            borderRadius2: 8,
            borderRadius3: 16,
            borderRadius4: 24,
        },
        palette: {
            background: {
                default: '#FFF',
                header: '#FAFAFA',
            },
            text: {
                primary: '#212121',
                secondary: '#616161',
                disabled: '#9E9E9E',
            },
            primary: {
                main: '#018923',
                dark: '#005A00',
                light: '#23A937',
                contrastText: '#FFFFFF',
                hover: '#0189230A',
                selected: '#01892314',
                focus: '#0189231F',
                focusVisible: '#0189234D',
                outlinedBorder: '#0189234D',
            },
            success: {
                main: '#007817',
            },
            warning: {
                main: '#EF6C00',
            },
            info: {
                main: '#010101',
            },
            error: {
                main: '#C62828',
            },
            divider: '#0000001F',
            default: {
                main: '#FFF',
            },
        },
        typography: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            h1: { fontSize: '6rem', fontWeight: 700, lineHeight: '116.7%', letterSpacing: '-0.09rem' },
            h2: { fontSize: '3.75rem', fontWeight: 700, lineHeight: '120%', letterSpacing: '-0.03rem' },
            h3: { fontSize: '3rem', fontWeight: 700, lineHeight: '116.7%' },
            h4: { fontSize: '2.125rem', fontWeight: 700, lineHeight: '123.5%', letterSpacing: '0.015rem' },
            h5: { fontSize: '1.5rem', fontWeight: 700, lineHeight: '133.4%' },
            h6: { fontSize: '1.25rem', fontWeight: 700, lineHeight: '160%', letterSpacing: '0.009rem' },
            subtitle1: { fontSize: '1rem', fontWeight: 400, lineHeight: '175%', letterSpacing: '0.009rem' },
            subtitle2: { fontSize: '0.875rem', fontWeight: 500, lineHeight: '157%', letterSpacing: '0.006rem' },
            body1: { fontSize: '1rem', fontWeight: 400, lineHeight: '150%', letterSpacing: '0.009rem' },
            body2: { fontSize: '0.875rem', fontWeight: 400, lineHeight: '143%', letterSpacing: '0.010rem' },
            caption: { fontSize: '0.75rem', fontWeight: 400, lineHeight: '166%', letterSpacing: '0.025rem' },
            overline: { fontSize: '0.75rem', fontWeight: 400, lineHeight: '266%', letterSpacing: '0.0625rem' },
        },
        components: {
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        display: 'flex', justifyContent: 'center'
                    },
                },
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        fontWeight: 500, '.MuiFormLabel-asterisk': { color: '#C62828' }
                    },
                },
            },
            MuiTablePagination: {
                styleOverrides: {
                    toolbar: {
                        alignItems: 'baseline',
                    },
                },
            },
            MuiChip: {
                variants: [
                    {
                        props: { color: 'success' },
                        style: {
                            color: '#FFF',
                            backgroundColor: '#007817',
                        },
                    },
                    {
                        props: { color: 'warning' },
                        style: {
                            color: '#FFF',
                            backgroundColor: '#EF6C00',
                        },
                    },
                    {
                        props: { color: 'error' },
                        style: {
                            color: '#FFF',
                            backgroundColor: '#C62828',
                        },
                    },
                    {
                        props: { color: 'info' },
                        style: {
                            color: '#FFF',
                            backgroundColor: '#0288D1',
                        },
                    },
                ],
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        color: '#0000008C'
                    }
                }
            }
        },
    },
    ptBR
);

export default ProduttivoMuiThemeV2;
